import { defineComponent as _defineComponent } from 'vue'
import Vue, { computed } from 'vue';

import PictureComp from '@/components/picture/PictureComp.vue';

import { ThumborOptions } from '@/filters/thumbor';
import { FormattedCompetitor, CompetitorComposition } from '@/helpers/sports/config/singleStepContexts';


export default /*#__PURE__*/_defineComponent({
  __name: 'CompetitorLogo',
  props: {
    competitor: null,
    size: { default: 'small' }
  },
  setup(__props: any) {

const props = __props as { competitor: FormattedCompetitor, size: 'big' | 'small' };



const imageProps = {
	png: {
		type: 'image/png',
		extension: '.png',
	},
};
const imagePropFilter = ['png'];

const imageProfile = computed(() => (props.size === 'big' ? 'competitor_icon' : 'competitor_small_icon'));

const logo = computed(() => {
	return Vue.filter('Thumbor')({
		url: props.competitor?.iconUrl ?? '',
		imageType: imageProfile.value,
		extension: '', // we already have the extension with the format param
	} as ThumborOptions);
});

const fallbackIcon = computed(() => {
	return props.competitor.sportCategory === CompetitorComposition.Player
		? `/${ASSETS_DIR}/img/sports/icons/player-placeholder.svg`
		: `/${ASSETS_DIR}/img/sports/icons/team-placeholder.svg`;
});

return { __sfc: true,props, imageProps, imagePropFilter, imageProfile, logo, fallbackIcon, PictureComp }
}

})